export class Direction {
  static NONE = ''

  static HOR = 'horizental'

  static VER = 'vertical'
}



// WEBPACK FOOTER //
// ./packages/utils/direction.js